const SKILL_CATEGORY_EMOJI_MAP: Record<string, string> = {
  // Skill taxonomy
  "Developer Tools": "💻",
  "Code Review": "🔍",
  DevOps: "⚙️",
  "Data Analysis": "📊",
  "ML/AI": "🤖",
  Writing: "✍️",
  Design: "🎨",
  Content: "📝",
  Marketing: "🎯",
  Product: "📦",
  Research: "🔬",
  Security: "🔒",
  UX: "🎨",
  QA: "✅",
  Operations: "🔧",
  Finance: "💰",
  Legal: "⚖️",
  Sales: "💼",
  Support: "🎧",
  Education: "📚",
  // Story-style categories (for cross-context use)
  "Agentic Engineering": "🦾",
  "Models & APIs": "🧠",
  "Inference & Infrastructure": "⚡",
  "Security & Reliability": "🔒",
  "Research & Benchmarks": "🔬",
  "Agent Development": "🧩",
  "Cost & Operations": "💰",
  "Business & Policy": "📊",
  "Voice Agents": "🎙️",
};

export function getSkillCategoryEmoji({
  category,
}: {
  category: string | null | undefined;
}): string | null {
  if (!category) {
    return null;
  }
  return SKILL_CATEGORY_EMOJI_MAP[category] ?? null;
}
